import '@/js/Controls'
import '@/js/UI'

// Enable animations after all the JS has been initialised
requestAnimationFrame(() => document.body.classList.remove('disable-animations'))

// Webpack HMR
if (module.hot) {
	module.hot.accept()
}
